<template>
  <section class="py-6 md:py-10">
    <h2 class="section-heading mb-5 text-center md:text-left">
      {{ title }}
    </h2>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
      <template v-if="isLoading">
        <div v-for="i in props.cardCount" :key="i">
          <UtilsSkeletonLoading class="rounded-lg h-40 w-full mb-4 card-img" />
          <UtilsSkeletonLoading class="w-full h-14 mb-3" />
          <UtilsSkeletonLoading class="w-full h-12" />
        </div>
      </template>

      <template v-else>
        <ArticleCard
          v-for="item in ourProducts"
          :key="item.id"
          :with-logo="false"
          :title="item?.attributes?.title"
          :desc="item?.attributes?.description"
          :slug="`/products/${item?.attributes?.slug}`"
          :image-url="item?.attributes?.image?.data?.attributes?.url"
        />
        <template v-if="isLoadingMore">
          <div v-for="i in 3" :key="i">
            <UtilsSkeletonLoading
              class="rounded-lg h-40 w-full mb-4 card-img"
            />
            <UtilsSkeletonLoading class="w-full h-14 mb-3" />
            <UtilsSkeletonLoading class="w-full h-12" />
          </div>
        </template>
      </template>
    </div>
    <div
      v-if="
        ourProductsMeta?.pagination?.page <
        ourProductsMeta?.pagination?.pageCount
      "
      class="mx-auto text-center mt-8 md:mt-10"
    >
      <CommonLoadMoreButton @click="loadMore" />
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  filterSolution: {
    type: String,
    default: null
  },
  title: {
    type: String,
    default: ''
  }
})

const isLoading = ref(true)
const isLoadingMore = ref(false)
const page = ref(1)

const ourProducts = ref([])
const ourProductsMeta = ref([])

const getOurProducts = async () => {
  const query = {
    'pagination[page]': page,
    'pagination[pageSize]': 6,
    'fields[0]': 'id',
    'fields[1]': 'title',
    'fields[2]': 'description',
    'fields[3]': 'slug',
    'fields[4]': 'content',
    'fields[5]': 'image',
    'populate[image][fields][0]': 'url'
  }

  if (props.filterSolution) {
    query['filters[$and][0][solutions][title][$in][0]'] = props.filterSolution
  }

  const { data, error, pending } = await useSuitmediaApiData('/api/products', {
    query
  })

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Products does not exist`
    })
  }

  return data.value
}

const products = await getOurProducts()
ourProducts.value = products.data
ourProductsMeta.value = products.meta

const loadMore = async e => {
  e.currentTarget.blur()
  isLoadingMore.value = true
  page.value++

  const newData = await getOurProducts(true)
  ourProducts.value = [...ourProducts.value, ...newData.data]
  ourProductsMeta.value = newData.meta

  isLoadingMore.value = false
}
</script>

<style lang="scss" scoped></style>
